import { render, staticRenderFns } from "./SetLang.vue?vue&type=template&id=c7fe4f06&scoped=true&"
import script from "./SetLang.vue?vue&type=script&lang=js&"
export * from "./SetLang.vue?vue&type=script&lang=js&"
import style0 from "./SetLang.vue?vue&type=style&index=0&id=c7fe4f06&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7fe4f06",
  null
  
)

export default component.exports